var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8835 4.41895C18.5639 4.41895 18.3037 4.67909 18.3037 4.99875C18.3037 5.31841 18.5639 5.57855 18.8835 5.57855C19.2032 5.57855 19.4633 5.31845 19.4633 4.99875C19.4633 4.67904 19.2032 4.41895 18.8835 4.41895Z",
    fill: "#FF583D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9409 6.80127C9.10664 6.80127 6.80078 9.10713 6.80078 11.9414C6.80078 14.7756 9.10664 17.0815 11.9409 17.0815C14.7752 17.0815 17.0811 14.7757 17.0811 11.9414C17.0811 9.10718 14.7752 6.80127 11.9409 6.80127Z",
    fill: "#FF583D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3354 0H6.54698C2.93697 0 0 2.93697 0 6.54703V17.3354C0 20.9454 2.93697 23.8824 6.54698 23.8824H17.3354C20.9454 23.8824 23.8824 20.9454 23.8824 17.3354V6.54703C23.8824 2.93697 20.9454 0 17.3354 0ZM11.9412 18.4917C8.3292 18.4917 5.39074 15.5531 5.39074 11.9412C5.39074 8.3292 8.32925 5.39079 11.9412 5.39079C15.5531 5.39079 18.4917 8.32925 18.4917 11.9412C18.4917 15.5531 15.5531 18.4917 11.9412 18.4917ZM18.8834 6.98913C17.7861 6.98913 16.8933 6.09634 16.8933 4.99897C16.8933 3.90159 17.7861 3.00876 18.8834 3.00876C19.9808 3.00876 20.8736 3.90155 20.8736 4.99892C20.8736 6.0963 19.9808 6.98913 18.8834 6.98913Z",
    fill: "#FF583D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.658cb6a0b3d06aff0b2fc08458a76ab5.svg";
export { ForwardRef as ReactComponent };